import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { WebVideo } from "../../Video/WebVideo/WebVideo";
import styles from "./HistoryCredibilitySlice.module.scss";
import classnames from 'classnames';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var HistoryCredibilitySlice = function HistoryCredibilitySlice(_ref) {
  var headerText = _ref.headerText,
    headerTextMobile = _ref.headerTextMobile,
    subheaderText = _ref.subheaderText,
    _ref$videoSrc = _ref.videoSrc,
    videoSrc = _ref$videoSrc === void 0 ? '' : _ref$videoSrc,
    _ref$videoPoster = _ref.videoPoster,
    videoPoster = _ref$videoPoster === void 0 ? '' : _ref$videoPoster,
    _ref$videoPosterMobil = _ref.videoPosterMobile,
    videoPosterMobile = _ref$videoPosterMobil === void 0 ? '' : _ref$videoPosterMobil,
    _ref$videoAccountId = _ref.videoAccountId,
    videoAccountId = _ref$videoAccountId === void 0 ? '' : _ref$videoAccountId,
    _ref$videoPlayerId = _ref.videoPlayerId,
    videoPlayerId = _ref$videoPlayerId === void 0 ? '' : _ref$videoPlayerId,
    _ref$videoId = _ref.videoId,
    videoId = _ref$videoId === void 0 ? '' : _ref$videoId,
    _ref$autoPlayOnScroll = _ref.autoPlayOnScroll,
    autoPlayOnScroll = _ref$autoPlayOnScroll === void 0 ? true : _ref$autoPlayOnScroll,
    _ref$percentScrollToP = _ref.percentScrollToPlay,
    percentScrollToPlay = _ref$percentScrollToP === void 0 ? 0.5 : _ref$percentScrollToP,
    _ref$percentScrollToS = _ref.percentScrollToStop,
    percentScrollToStop = _ref$percentScrollToS === void 0 ? 0.85 : _ref$percentScrollToS,
    _ref$muted = _ref.muted,
    muted = _ref$muted === void 0 ? true : _ref$muted;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mobileVideoPlaying = _useState2[0],
    setMobileVideoPlaying = _useState2[1];
  var handleMobilePlay = function handleMobilePlay() {
    setMobileVideoPlaying(true);
  };
  var mobilePoster = videoPosterMobile || videoPoster;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.topSection,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.textContainer,
        children: [headerText && /*#__PURE__*/_jsx("h2", {
          className: classnames(styles.title, styles.desktop),
          children: headerText
        }), headerTextMobile && /*#__PURE__*/_jsx("h2", {
          className: classnames(styles.title, styles.mobile),
          children: headerTextMobile
        }), /*#__PURE__*/_jsx("p", {
          className: styles.subtitle,
          children: subheaderText
        })]
      })
    }), videoSrc && /*#__PURE__*/_jsxs("div", {
      className: styles.videoSection,
      children: [/*#__PURE__*/_jsxs("div", {
        className: classnames(styles.mobileVideoContainer, styles.mobile),
        children: [!mobileVideoPlaying && mobilePoster && /*#__PURE__*/_jsx("div", {
          className: styles.mobilePosterOverlay,
          children: /*#__PURE__*/_jsx("img", {
            src: mobilePoster,
            alt: "Video thumbnail"
          })
        }), /*#__PURE__*/_jsx(WebVideo, {
          src: videoSrc,
          poster: mobilePoster,
          accountId: videoAccountId,
          playerId: "".concat(videoPlayerId, "-mobile"),
          videoId: videoId,
          muted: muted,
          autoplay: autoPlayOnScroll,
          autoPlayOnScroll: autoPlayOnScroll,
          percentScrollToPlay: percentScrollToPlay,
          percentScrollToStop: percentScrollToStop,
          onPlay: handleMobilePlay
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.desktop,
        children: /*#__PURE__*/_jsx(WebVideo, {
          src: videoSrc,
          poster: videoPoster,
          accountId: videoAccountId,
          playerId: videoPlayerId,
          videoId: videoId,
          muted: muted,
          autoPlayOnScroll: autoPlayOnScroll,
          percentScrollToPlay: percentScrollToPlay,
          percentScrollToStop: percentScrollToStop,
          autoplay: autoPlayOnScroll
        })
      })]
    })]
  });
};